export default {
  balance: {
    en: 'Balance',
  },
  inBets: {
    en: 'In bets',
  },
  toRedeem: {
    en: 'To redeem',
  },
  unavailable: {
    en: 'Unavailable',
  },
  summaryUnavailable: {
    en: 'Bet totals are temporarily unavailable. Check My bets for individual bets.',
  },
}
